import { Container } from "react-bootstrap"
import IconNotificationCount from '../../assets/images/notification-icon.svg'
import IconNotification from '../../assets/images/notificationIcon.svg'
import { Link } from "react-router-dom"
import Logos from "../Logos"
import WebService from "../../Services/WebService"
import { useEffect, useState } from "react"

const Header = () => {
    // Toggle 'menu-open' class on body
    const handleMenuToggle = () => {
        document.body.classList.toggle('menu-open');
    };

    const [notificationCount, setNotificationCount] = useState(0);

    useEffect(() => {
        fetchNotificationCount();

        const handleRefresh = () => {
            fetchNotificationCount();
        };

        window.addEventListener('refresh-notification-count', handleRefresh);

        return () => {
            window.removeEventListener('refresh-notification-count', handleRefresh);
        };
    }, []);

    const fetchNotificationCount = async () => {
        WebService.getAPI({
            action: `customer-home/count-notifications`,
            isHideToast: true,
            isHideError: true,
        })
            .then((res: any) => {
                setNotificationCount(res.notification_count)
            })
            .catch((err: any) => {
                if (err.status == 401) {
                    localStorage.removeItem('access_token');
                }
                return;
            });


    };

    return (
        <>
            <header className="site-header">
                <Container fluid className='d-flex justify-content-between align-items-center px-0'>
                    <Logos />
                    <div className="p-3">
                        <div className="d-flex gap-3 justify-content-end align-items-center">
                            <Link to="/notifications"><img src={notificationCount > 0 ? IconNotificationCount : IconNotification} alt="Notification Icon" width={24} /></Link>
                            <button type="button" className="btn btn-link p-0 border-0" id="menu-toggle" onClick={handleMenuToggle}>
                                <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.25 11.6345C1.0375 11.6345 0.859417 11.5626 0.71575 11.4187C0.571917 11.2751 0.5 11.0969 0.5 10.8842C0.5 10.6717 0.571917 10.4936 0.71575 10.35C0.859417 10.2065 1.0375 10.1347 1.25 10.1347H16.75C16.9625 10.1347 17.1406 10.2066 17.2843 10.3502C17.4281 10.4941 17.5 10.6723 17.5 10.885C17.5 11.0975 17.4281 11.2756 17.2843 11.4192C17.1406 11.5627 16.9625 11.6345 16.75 11.6345H1.25ZM1.25 6.74998C1.0375 6.74998 0.859417 6.67806 0.71575 6.53423C0.571917 6.3904 0.5 6.21223 0.5 5.99973C0.5 5.78706 0.571917 5.60898 0.71575 5.46548C0.859417 5.32181 1.0375 5.24998 1.25 5.24998H16.75C16.9625 5.24998 17.1406 5.3219 17.2843 5.46573C17.4281 5.60956 17.5 5.78773 17.5 6.00023C17.5 6.2129 17.4281 6.39098 17.2843 6.53448C17.1406 6.67815 16.9625 6.74998 16.75 6.74998H1.25ZM1.25 1.86523C1.0375 1.86523 0.859417 1.7934 0.71575 1.64973C0.571917 1.5059 0.5 1.32764 0.5 1.11498C0.5 0.902478 0.571917 0.724395 0.71575 0.580728C0.859417 0.437228 1.0375 0.365479 1.25 0.365479H16.75C16.9625 0.365479 17.1406 0.437395 17.2843 0.581229C17.4281 0.724895 17.5 0.903062 17.5 1.11573C17.5 1.32823 17.4281 1.50631 17.2843 1.64998C17.1406 1.79348 16.9625 1.86523 16.75 1.86523H1.25Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </Container>
            </header>
        </>
    )
}
export default Header;